import { FormControlLabel, FormControl, RadioGroup, Radio, Stack, Box, Alert } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { CampaignCostHandlingMethod, FormatVersion } from '~/generated/graphql'
import { z } from 'zod'
import { CreditCardRegistrationAlert } from '~/components/common/CreditCardRegistrationAlert'

export const selectCostHandlingMethodSchemaFields = {
  costHandlingMethod: z.nativeEnum(CampaignCostHandlingMethod),
}
export const selectCostHandlingMethodSchema = z.object(selectCostHandlingMethodSchemaFields)

export const SelectCostHandlingMethod = ({
  isExpenseCampaignAllowed,
  description,
  tooltip,
}: CampaignInputComponentProps & {
  isExpenseCampaignAllowed: boolean
}) => {
  const { control } = useFormContext<z.infer<typeof selectCostHandlingMethodSchema>>()

  return (
    <CampaignInputComponent
      title="精算形式設定"
      tooltip={tooltip}
      required={true}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
    >
      <Stack position="relative">
        <Alert severity="info">
          <Box>{description}</Box>
        </Alert>
      </Stack>
      <Controller
        control={control}
        name="costHandlingMethod"
        render={({ field: { ref, ...field } }) => (
          <FormControl>
            <RadioGroup
              {...field}
              ref={ref}
              defaultValue={CampaignCostHandlingMethod.ExpenseCampaign}
            >
              <FormControlLabel
                value={CampaignCostHandlingMethod.ExpenseCampaign}
                control={<Radio />}
                label="インフルエンサー立替型"
                sx={{ width: 'fit-content' }}
                disabled={!isExpenseCampaignAllowed}
              />
              <FormControlLabel
                value={CampaignCostHandlingMethod.NoChargeCampaign}
                control={<Radio />}
                label="無償提供型"
                sx={{ width: 'fit-content' }}
              />
            </RadioGroup>
          </FormControl>
        )}
      />
      {isExpenseCampaignAllowed ? null : <CreditCardRegistrationAlert />}
    </CampaignInputComponent>
  )
}
